import React, { useState } from 'react';
import { AUDIT_MODULES, AUDIT_ACTIONS } from '../../../../services/audit_service';
import { NeoInput, NeoButton, NeoDatePicker } from '../../../../components/Common';

// Converte os objetos CONSTANTES para arrays formatados de select
const moduleOptions = Object.keys(AUDIT_MODULES).map(key => ({
    value: AUDIT_MODULES[key],
    label: AUDIT_MODULES[key]
})).sort((a,b) => a.label.localeCompare(b.label));

const actionOptions = Object.keys(AUDIT_ACTIONS).map(key => ({
    value: AUDIT_ACTIONS[key],
    label: AUDIT_ACTIONS[key]
}));

/**
 * AuditFilters — Painel de filtros de logs de auditoria.
 * Migrado 100% para o Neo Design System com NeoInput, NeoDatePicker e NeoButton.
 */
const AuditFilters = ({ filters, onFilterSubmit, onClearFilters }) => {
    // Estado local para os inputs (só dispara a busca ao clicar em Filtrar)
    const [localFilters, setLocalFilters] = useState({ ...filters });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (name, val) => {
        setLocalFilters(prev => ({ ...prev, [name]: val }));
    };

    const handleApply = () => {
        onFilterSubmit(localFilters);
    };

    const handleClear = () => {
        const cleared = { module: "", action: "", startDate: "", endDate: "", userId: "" };
        setLocalFilters(cleared);
        onClearFilters();
    };

    return (
        <div className="w-100 mb-3 pt-2">
            <div className="row g-3 align-items-end">
                {/* Seletores de Módulos e Ações */}
                <div className="col-12 col-sm-6 col-md-3">
                    <NeoInput
                        label="Módulo"
                        type="select"
                        name="module"
                        value={localFilters.module}
                        onChange={handleChange}
                        options={moduleOptions}
                        placeholder="Todos os Módulos"
                        size="sm"
                    />
                </div>

                <div className="col-12 col-sm-6 col-md-2">
                    <NeoInput
                        label="Ação"
                        type="select"
                        name="action"
                        value={localFilters.action}
                        onChange={handleChange}
                        options={actionOptions}
                        placeholder="Todas"
                        size="sm"
                    />
                </div>

                {/* Seletores de Data Popup Premium */}
                <div className="col-12 col-sm-6 col-md-2">
                    <NeoDatePicker
                        label="Data Início"
                        value={localFilters.startDate}
                        onChange={(val) => handleDateChange("startDate", val)}
                        placeholder="Início..."
                        size="sm"
                    />
                </div>

                <div className="col-12 col-sm-6 col-md-2">
                    <NeoDatePicker
                        label="Data Fim"
                        value={localFilters.endDate}
                        onChange={(val) => handleDateChange("endDate", val)}
                        placeholder="Fim..."
                        size="sm"
                    />
                </div>

                {/* Botões de Ação */}
                <div className="col-12 col-md-3 d-flex align-items-center justify-content-end gap-2 mt-2 mt-md-0 pb-1">
                    <NeoButton 
                        variant="outline-chocolate" 
                        size="sm"
                        icon="mdi-filter-remove-outline"
                        onClick={handleClear}
                        style={{ height: '34px', minWidth: '90px' }}
                    >
                        Limpar
                    </NeoButton>
                    <NeoButton 
                        variant="primary" 
                        size="sm"
                        icon="mdi-filter"
                        onClick={handleApply}
                        style={{ height: '34px', minWidth: '90px' }}
                    >
                        Filtrar
                    </NeoButton>
                </div>
            </div>
        </div>
    );
};

export default AuditFilters;
